import { createSchemaPlugin } from '../../factories/createSchemaPlugin'
import { SchemaMapDefinition } from './TypedDefinition'

export const SchemaMapPlugin = createSchemaPlugin(
  'Schema.Map',
  SchemaMapDefinition
)
